<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Bulk Activate Newer External Data</h4>
</div>

<div class="modal-body" hsDraggable="modal-dialog">
  <nf-form-control>
    <label for="dateRange">Recon Date Range</label>
    <nf-daterange
      id="dateRange"
      name="dateRange"
      [ngModel]="dateRange"
      (ngModelChange)="applyDateRange($event)"
      [beginDateRequired]="true"
      [endDateRequired]="true"
    ></nf-daterange>

    <br />
    <label for="selectedAccounts"
      >Selected Accounts ({{ selectedAccountIds?.split(',')?.length }})</label
    >
    <input
      id="selectedAccounts"
      type="text"
      class="form-control"
      [(ngModel)]="selectedAccountIds"
    />
    <br />

    <input
      type="radio"
      name="dataSource"
      id="custody"
      value="CUSTODY"
      [(ngModel)]="dataSource"
    />
    <label for="custody" style="margin-right: 2rem">Custody</label>

    <input
      type="radio"
      name="dataSource"
      id="trading"
      value="TRADING"
      [(ngModel)]="dataSource"
    />
    <label for="trading">Trading</label>
  </nf-form-control>
</div>

<div class="modal-footer" hsDraggable="modal-dialog">
  <div>
    <button nf-button="cancel" (click)="activeModal.dismiss()">Cancel</button>
    <button (click)="onRunAccounts()" nf-button="save">Run Accounts</button>
  </div>
</div>
